import { downloadApk } from '../../../utils/downloadApk';

export function PlayAnywhereSection() {
  return (
    <section className="play-anywhere-bg relative py-16 md:py-24 px-4 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-darker via-darker/65 to-darker/45" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-row items-center gap-6 md:gap-12">
          <div className="w-1/2 space-y-3 md:space-y-6">
            <h2 className="text-xl sm:text-3xl md:text-5xl font-serif font-black leading-tight">
              Play Anywhere,
              <br />
              <span className="text-primary">Win Everywhere</span>
            </h2>
            <p className="hidden sm:block text-slate-300 text-sm md:text-lg leading-relaxed">
              Our award-winning mobile platform brings the excitement of Golden 777 directly to your fingertips. HD graphics, seamless gameplay, and instant access to your favorite tables.
            </p>
            <p className="sm:hidden text-slate-300 text-xs leading-relaxed">
              HD graphics, seamless gameplay and instant table access.
            </p>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
              <div className="flex items-center gap-1">
                <span className="material-icons text-accent text-sm md:text-xl">check_circle</span>
                <span className="font-bold text-xs sm:text-sm">Android APK</span>
              </div>
              <div className="flex items-center gap-1">
                <span className="material-icons text-accent text-sm md:text-xl">check_circle</span>
                <span className="font-bold text-xs sm:text-sm">Free to Download</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={downloadApk}
                className="group w-full sm:w-auto px-6 md:px-8 py-2.5 md:py-3 bg-accent text-darker font-black text-xs sm:text-sm rounded-full hover:bg-white transition-all uppercase tracking-wider shadow-lg shadow-accent/25 flex items-center justify-center gap-2"
              >
                <span className="material-icons text-lg">play_arrow</span>
                Play Now
              </button>
              <button
                type="button"
                onClick={downloadApk}
                className="group w-full sm:w-auto px-6 md:px-8 py-2.5 md:py-3 bg-white/10 border border-white/20 text-white font-bold text-xs sm:text-sm rounded-full hover:bg-white/20 transition-all uppercase tracking-wider flex items-center justify-center gap-2"
              >
                <span className="material-icons text-lg">download</span>
                Download APK
              </button>
            </div>
          </div>

          <div className="w-1/2 flex justify-end relative">
            <div className="absolute -top-6 -right-4 w-32 h-32 md:w-64 md:h-64 bg-primary/20 rounded-full blur-3xl pointer-events-none" />
            <img
              alt="Mobile Casino Experience"
              className="relative z-10 w-full max-w-xs md:max-w-none rounded-2xl md:rounded-3xl shadow-2xl -rotate-2 hover:rotate-0 transition-transform duration-500 object-cover"
              src="/assets/welcome/1.png"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
